import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { LocationDescriptor } from 'history';
import { categoryContent_exploreCategory_subCategories as ExploreSubCategory } from '../../Category/__generated__/categoryContent';
import SubCategoryCard from '../SubCategoryCard/SubCategoryCard';

export interface SubCategoryListProps {
  categories: ExploreSubCategory[];
  getCategoryTo(slug: string, title: string): LocationDescriptor;
}

const SubCategoryCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${rem(24)};
  width: 100%;
`;

function SubCategoryList({ categories, getCategoryTo }: SubCategoryListProps) {
  return (
    <SubCategoryCardsContainer>
      {categories.map(category => (
        <SubCategoryCard
          key={category.id}
          category={category}
          getCategoryTo={getCategoryTo}
        />
      ))}
    </SubCategoryCardsContainer>
  );
}

export default SubCategoryList;
